export default __webpack_public_path__ + "static/media/Union.2b0723b7.svg";